module.exports = __webpack_public_path__ + "static/media/Blue_Small.c2aac74b.webp";